var _g, _circle, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAssetsBitcoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_599_12619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.3715 24.8674C36.7004 35.5818 25.8484 42.1024 15.1328 39.4305C4.42158 36.7594 -2.09898 25.9068 0.573336 15.1932C3.24331 4.47768 14.0952 -2.04338 24.8076 0.627765C35.5225 3.29891 42.0426 14.1527 39.3712 24.8676L39.3714 24.8674H39.3715Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.8192 17.1506C29.2173 14.489 27.191 13.0583 24.4201 12.1039L25.319 8.49857L23.1243 7.95171L22.2493 11.4621C21.6723 11.3182 21.0798 11.1826 20.4909 11.0482L21.3723 7.51463L19.179 6.96777L18.2796 10.5719C17.8022 10.4632 17.3332 10.3558 16.8782 10.2426L16.8808 10.2312L13.8543 9.47547L13.2705 11.8195C13.2705 11.8195 14.8987 12.1928 14.8644 12.2157C15.7532 12.4375 15.9139 13.0258 15.8872 13.4922L14.8633 17.5995C14.9245 17.615 15.0038 17.6375 15.0914 17.6727C15.0182 17.6545 14.9403 17.6347 14.8594 17.6153L13.4243 23.3691C13.3156 23.6391 13.04 24.0443 12.4186 23.8904C12.4406 23.9223 10.8235 23.4923 10.8235 23.4923L9.73389 26.0045L12.5899 26.7165C13.1212 26.8497 13.6419 26.9891 14.1546 27.1202L13.2464 30.7669L15.4386 31.3138L16.3379 27.7058C16.9368 27.8684 17.518 28.0183 18.0869 28.1597L17.1906 31.7506L19.3854 32.2975L20.2934 28.6577C24.0358 29.3659 26.8498 29.0804 28.0342 25.6954C28.9886 22.9701 27.9867 21.3982 26.0179 20.3731C27.4519 20.0423 28.532 19.0992 28.82 17.1509L28.8193 17.1504L28.8192 17.1506ZM23.8049 24.1819C23.1267 26.9072 18.5381 25.434 17.0504 25.0646L18.2556 20.2334C19.7432 20.6047 24.5137 21.3397 23.805 24.1819H23.8049ZM24.4836 17.1111C23.8649 19.59 20.0458 18.3306 18.8069 18.0218L19.8996 13.6402C21.1385 13.949 25.1282 14.5254 24.4838 17.1111H24.4836Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 4,
    fill: "#FACC16"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_599_12619"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssetsBitcoin);
export default __webpack_public_path__ + "static/media/assetsBitcoin.de68cdf065327f32be01b548212826fb.svg";
export { ForwardRef as ReactComponent };